import { useEffect, useState } from 'react';
import { useStudentBadgeData } from '../../hooks/useStudentBadgeData';

export const XPProgress = () => {
  const { studentXP } = useStudentBadgeData();
  const [animate, setAnimate] = useState(false);
  const progress = { current: studentXP, required: 100, percentage: Math.min((studentXP / 100) * 100, 100) };
  const nextBadge: { name: string } | null = studentXP < 100 ? { name: 'Next Badge' } : null;

  useEffect(() => {
    // Start animation after component mounts
    setAnimate(true);
  }, []);

  return (
    <div className="bg-white rounded-lg shadow-md p-6 mb-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">Your XP Progress</h2>
        </div>
        <div className="mt-4 md:mt-0">
          <span className="text-4xl font-bold text-indigo-600">{studentXP} XP</span>
        </div>
      </div>

      {nextBadge ? (
        <>
          <div className="relative pt-1">
            <div className="flex items-center justify-between mb-2">
              <div>
                <span className="text-xs font-semibold inline-block text-indigo-600">
                  Progress to {nextBadge.name}
                </span>
              </div>
              <div className="text-right">
                <span className="text-xs font-semibold inline-block text-indigo-600">
                  {progress.current} / {progress.required} XP
                </span>
              </div>
            </div>
            <div className="overflow-hidden h-3 mb-4 text-xs flex rounded-full bg-indigo-100">
              <div
                style={{ width: animate ? `${progress.percentage}%` : '0%' }}
                className="transition-all duration-1000 ease-out shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-indigo-500"
              ></div>
            </div>
          </div>
          <p className="text-sm text-gray-600">
            <span className="font-bold">{progress.required - progress.current} XP</span> needed for next level
          </p>
        </>
      ) : (
        <div className="h-2" />
      )}
    </div>
  );
};